import { useQuery } from "@tanstack/react-query";

import {
  ListPlanMapOptionsQueryFilters,
  UseListPlanMapOptionsQueryOptions,
} from "./types";
import { getPlanMapOptionsService } from "./service";

export const listPlanMapOptionsQueryKey = ["v1/integration_plan_map_option_admin"];

export function useListPlanMapOptionsQuery(
  filters: ListPlanMapOptionsQueryFilters,
  options?: UseListPlanMapOptionsQueryOptions
) {
  const queryKey = listPlanMapOptionsQueryKey.concat(JSON.stringify(filters));

  return useQuery({
    queryKey,
    queryFn: async () => getPlanMapOptionsService(filters),
    ...options,
  });
}
